import React from 'react';
import Modal from '../../common/Modal';

const QuotaAdjustmentModal = ({
  showQuotaModal,
  toggleQuotaModal,
  deleteWithReduce,
  quotaOpt,
}) => {
  return (
    <Modal
      title='quota-adjustment-modal'
      show={showQuotaModal}
      onClose={toggleQuotaModal}
    >
      <header>
        <h3>Notice</h3>
      </header>
      <div className='content'>
        <h4>
          This submission contains a selection that is currently closed:
          <p className='opt-quota-name'>{quotaOpt.value}</p>
          <ul>
            <li>
              "{quotaOpt.value}" will remain closed even if submission is
              deleted.
            </li>
            <li>
              If you need to update the status of this option, please submit a
              ticket to IT.
            </li>
          </ul>
          Proceed with Delete?
        </h4>

        <div className='controls'>
          <button onClick={deleteWithReduce}>Confirm Delete</button>
          <button onClick={toggleQuotaModal}>Cancel</button>
        </div>
      </div>
    </Modal>
  );
};

export default QuotaAdjustmentModal;
